// extracted by mini-css-extract-plugin
module.exports = {"butons":"styles_butons__1Upfw","butons1":"styles_butons1__1rU1H"};